export default __webpack_public_path__ + "beta-registration-locales/en-US.fd76cf6e4d2147bfa9f46a656f2eed3b.json";